import {InjectionToken} from '@angular/core';
import {ResizableDirective} from '@shared/resizable/resizable.directive';
import {ResizableHandleDirective} from '@shared/resizable/resizable-handle.directive';

export const RESIZABLE_PARENT = new InjectionToken<ResizableDirective>('ResizableDirective');
export const RESIZABLE_HANDLE = new InjectionToken<ResizableHandleDirective>('ResizableHandleDirective');
